import { SvgIconType } from './svg.interface';

const Visa: SvgIconType = ({ width = 16, height = 16, className = '' }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="16" height="16" rx="2" fill="#00579F" />
    <path
      d="M6.91149 9.93807H5.89987L6.53261 6.07011H7.54418L6.91149 9.93807Z"
      fill="white"
    />
    <path
      d="M10.5787 6.16467C10.3792 6.08641 10.0627 6 9.67137 6C8.67236 6 7.96886 6.52667 7.96455 7.27966C7.95625 7.83521 8.46823 8.14377 8.85115 8.32901C9.24253 8.5183 9.37558 8.64184 9.37558 8.81057C9.37159 9.06969 9.05932 9.18914 8.76806 9.18914C8.36417 9.18914 8.14777 9.12755 7.81889 8.98339L7.68568 8.92159L7.54412 9.78986C7.78139 9.89673 8.21852 9.99156 8.67236 9.99572C9.73382 9.99572 10.4249 9.47719 10.4331 8.67477C10.4371 8.23445 10.1668 7.89706 9.58391 7.62137C9.23009 7.44439 9.0134 7.32505 9.0134 7.14397C9.01755 6.97935 9.19667 6.81074 9.59608 6.81074C9.92495 6.80248 10.1666 6.88063 10.3496 6.95884L10.4411 6.99991L10.5787 6.16467Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3895 6.07011H13.172L13.9881 9.93802H13.0514C13.0514 9.93802 12.9598 9.4936 12.9307 9.3578H11.6319C11.5943 9.46062 11.4196 9.93802 11.4196 9.93802H10.3581L11.8607 6.39104C11.9648 6.14001 12.1482 6.07011 12.3895 6.07011ZM12.3271 7.48557C12.3271 7.48557 12.0066 8.34558 11.9232 8.56779H12.7641C12.7225 8.37441 12.5309 7.44854 12.5309 7.44854L12.4602 7.11526C12.4305 7.20108 12.3874 7.31907 12.3584 7.39866C12.3387 7.45261 12.3254 7.48891 12.3271 7.48557Z"
      fill="white"
    />
    <path
      d="M5.05492 6.07011L4.06421 8.70769L3.95595 8.17276C3.77279 7.55552 3.19836 6.8849 2.55732 6.55145L3.46477 9.93397H4.53454L6.12463 6.07011H5.05492Z"
      fill="white"
    />
    <path
      d="M3.14425 6.07011H1.51665L1.5 6.14827C2.76963 6.46925 3.61048 7.2428 3.95595 8.17276L3.60213 6.39525C3.54388 6.14821 3.36487 6.07826 3.14425 6.07011Z"
      fill="white"
    />
  </svg>
);

export default Visa;
